export default "__VITE_ASSET__CxETY_Dt__"